import { GlButton, GlFormGroup } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'BoardAddNewColumnForm',
    i18n: {
        add: __('Add to board'),
        cancel: __('Cancel'),
        newList: __('New list'),
        scope: __('Scope'),
        scopeDescription: __('Issues must match this scope to appear in this list.'),
        valueRequiredFieldFeedback: __('Value field is required.')
    },
    components: {
        GlButton,
        GlFormGroup
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        searchLabel: {
            type: String,
            required: false,
            default: null
        },
        selectedIdValid: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'add-list',
        'set-add-column-form-visibility'
    ],
    methods: {
        onSubmit () {
            this.$emit('add-list');
        }
    }
};
